import React from 'react';
import { Sparkles } from 'lucide-react';
import { LicenseCategory } from '../../types/license';

interface CopilotToggleProps {
  enabled: boolean;
  onChange: (enabled: boolean) => void;
  category: LicenseCategory;
}

export const CopilotToggle: React.FC<CopilotToggleProps> = ({ enabled, onChange, category }) => {
  const isBusiness = category === 'Microsoft 365 Business';

  return (
    <div className="flex items-center gap-3 p-3 bg-gradient-to-r from-blue-50 to-purple-50 rounded-lg">
      <button
        onClick={() => onChange(!enabled)}
        className={`flex items-center gap-2 px-4 py-2 rounded-md transition-colors ${
          enabled 
            ? 'bg-blue-600 text-white' 
            : 'bg-white text-gray-700 border border-gray-200 hover:bg-gray-50'
        }`}
      >
        <Sparkles className="w-4 h-4" />
        <span>{isBusiness ? 'Microsoft 365 Copilot Business' : 'Microsoft 365 Copilot'}</span>
      </button>
      
      <div className="text-sm text-gray-600">
        {enabled
          ? isBusiness
            ? '+$21/user/month list'
            : '+$30/user/month'
          : 'Add Copilot capabilities'}
      </div>
    </div>
  );
};